if (!customElements.get('ck-reviews')) {
  customElements.define(
    'ck-reviews',
    class CkReviews extends HTMLElement {
      constructor() {
        super();
        this.swiper = null;
        this.swiperModule = null;
        this.sectionId = this.getAttribute('data-section-id');
        this.slidesDesktop = Number(this.getAttribute('data-slides-desktop')) || 2.3;
        this.slidesMobile = Number(this.getAttribute('data-slides-mobile')) || 1.2;
        this.gapDesktop = Number(this.getAttribute('data-gap-desktop')) || 16;
        this.gapMobile = Number(this.getAttribute('data-gap-mobile')) || 16;
        this.autoplay = this.getAttribute('data-autoplay') === 'true';
        this.autoplayDelay = Number(this.getAttribute('data-autoplay-delay')) || 3000;
      }

      connectedCallback() {
        if (window.Shopify?.designMode) {
          this.loadSwiper().then(() => this.initSwiper());
          return;
        }

        const observer = new IntersectionObserver(
          async (entries) => {
            if (entries[0].isIntersecting) {
              observer.disconnect();
              await this.loadSwiper();
              this.initSwiper();
            }
          },
          { rootMargin: '200px' }
        );
        observer.observe(this);
      }

      async loadSwiper() {
        if (!this.swiperModule) {
          this.swiperModule = await import('https://cdn.jsdelivr.net/npm/swiper@12/swiper-bundle.min.mjs');
        }
        return this.swiperModule;
      }

      initSwiper() {
        if (this.swiper || !this.swiperEls.swiperContainer) return;

        const Swiper = this.swiperModule.default;
        const { Navigation, Pagination, Autoplay } = this.swiperModule;
        const { swiperContainer, prev, next, pagination } = this.swiperEls;

        this.swiper = new Swiper(swiperContainer, {
          modules: [Navigation, Pagination, Autoplay],
          slidesPerView: this.slidesMobile,
          spaceBetween: this.gapMobile,
          watchOverflow: true,
          navigation: prev && next ? { nextEl: next, prevEl: prev } : false,
          pagination: pagination ? { el: pagination, clickable: true } : false,
          autoplay: this.autoplay ? { delay: this.autoplayDelay, disableOnInteraction: false } : false,
          observer: true,
          observeParents: true,
          breakpoints: {
            750: {
              slidesPerView: this.slidesDesktop,
              spaceBetween: this.gapDesktop,
            },
          },
        });
      }

      disconnectedCallback() {
        this.swiper?.destroy(true, true);
        this.swiper = null;
      }

      get swiperEls() {
        return {
          swiperContainer: this.querySelector(`[id^="Slider-${this.sectionId}"]`),
          prev: this.querySelector(`[id^="Slider-prev-${this.sectionId}"]`),
          next: this.querySelector(`[id^="Slider-next-${this.sectionId}"]`),
          pagination: this.querySelector(`[id^="Slider-pagination-${this.sectionId}"]`),
        };
      }
    }
  );
}
